import React from 'react';
import {
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Fade,
  Slide,
  Divider,
} from '@mui/material';
import { Link } from 'react-router-dom';
import WorkIcon from '@mui/icons-material/Work';
import HomeIcon from '@mui/icons-material/Home';
import AssignmentIcon from '@mui/icons-material/Assignment';
import HistoryIcon from '@mui/icons-material/History';
import { BASE_URL } from '../constants';
// import { BASE_URL } from '../../constants';


function Dashboard({ logoSrc = '/logo192.png' }) {
  // Mock statistics data
  

  return (
    <Box
      sx={{
        minHeight: '100vh',
      
        padding: { xs: '16px', md: '32px' },
        color: '#ffffff',
      }}
    >
      {/* Hero Section */}
      <Fade in timeout={1000}>
        <Box
          sx={{
            background: 'linear-gradient(135deg, #0288d1 0%, #26a69a 100%)',
            borderRadius: '8px',
            padding: { xs: '24px', md: '48px' },
            textAlign: 'center',
            mb: '32px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
          }}
        >
          <img
            src={process.env.PUBLIC_URL + '/logo.png'}
            alt="Dashboard Hero"
            style={{
              width: '300px',
              height: '200px',
              objectFit: 'contain', 
              padding: '16px',
              // borderRadius: '50%',
              // border: '2px solid #ffffff',
              boxShadow: '0 0 16px rgba(255,255,255,0.3)',
              marginBottom: '16px',
            }}
            onError={(e) => {
              e.target.src = process.env.PUBLIC_URL + '/logo192.png';
            }}
          />
          <Typography
            variant="h2"
            sx={{
              fontWeight: '800',
              fontSize: { xs: '2rem', md: '3.5rem' },
              mb: '16px',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)',
            }}
          >
            Projects Tracker Dashboard
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: '1rem', md: '1.25rem' },
              mb: '24px',
              maxWidth: '600px',
              margin: '0 auto',
              color: '#e0e0e0',
            }}
          >
            Take control of your construction projects with seamless management of projects.
          </Typography>
          <Button
            component={Link}
            to="/projects"
            variant="contained"
            color="secondary"
            size="large"
            sx={{
              textTransform: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              backgroundColor: '#26a69a',
              '&:hover': {
                backgroundColor: '#2bbbad',
                transform: 'scale(1.05)',
                transition: 'transform 0.2s ease',
              },
            }}
          >
            Start Managing Projects
          </Button>
        </Box>
      </Fade>

    

      
    
    </Box>
  );
}

export default Dashboard;